import { Aspect } from '@teambit/harmony';

export const APIReferenceAspect = Aspect.create({
  id: 'teambit.api-reference/api-reference',
});

export default APIReferenceAspect;
